/**
 * Category-aware variant suggestions for AfriMarket listings.
 * Used by `CreateListing.jsx` to render quick-add chips so sellers don't
 * have to type out every size by hand.
 *
 * Keep these maps in sync with `/api/meta` product_categories.
 */

// category → labelled preset groups
export const SIZE_PRESETS = {
  "Fashion & Ankara": {
    "Clothing": ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    "Shoes (UK)": ["UK 3", "UK 4", "UK 5", "UK 6", "UK 7", "UK 8", "UK 9", "UK 10", "UK 11", "UK 12"],
    "Shoes (EU)": ["EU 36", "EU 37", "EU 38", "EU 39", "EU 40", "EU 41", "EU 42", "EU 43", "EU 44", "EU 45"],
    "Trousers (waist)": ["W28", "W30", "W32", "W34", "W36", "W38", "W40", "W42"],
    "Kids age": ["Newborn", "0-3m", "3-6m", "6-12m", "1Y", "2Y", "3Y", "4Y", "5Y", "6Y"],
  },
  "Jewelry": {
    "Ring (UK)": ["G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T"],
    "Bracelet": ["Small", "Medium", "Large"],
    "Chain length (in)": ['16"', '18"', '20"', '22"', '24"'],
  },
  "Beauty & Hair": {
    "Hair length (in)": ['8"', '10"', '12"', '14"', '16"', '18"', '20"', '22"', '24"', '26"', '28"', '30"'],
    "Volume": ["50ml", "100ml", "200ml", "250ml", "500ml"],
  },
  "Home & Decor": {
    "Size": ["Small", "Medium", "Large", "Extra-large"],
    "Dimensions": ["Twin", "Double", "Queen", "King"],
  },
  "Food & Spices": {
    "Pack size": ["100g", "250g", "500g", "1kg", "2kg", "5kg"],
  },
  "Art & Crafts": {
    "Print size": ['A5', 'A4', 'A3', 'A2', 'A1'],
  },
};

// Universal colour suggestions — diaspora fashion-leaning palette
export const COLOR_PRESETS = [
  "Black", "White", "Cream", "Navy", "Brown", "Beige",
  "Red", "Burgundy", "Maroon", "Indigo", "Mustard", "Gold",
  "Forest green", "Olive", "Charcoal", "Coral",
];

export const sizePresetsFor = (category) => SIZE_PRESETS[category] || null;
